import gql from 'graphql-tag';

export default gql`
    query GetAssestLoadsByLoadId($loadId: Int) {
        getAssestLoadsByLoadId(loadId: $loadId) {
            id
            assetLoadType
            assetLoadTypeId
            originType
            originJob
            originJobId
            originLofa
            originLofaId
            originYard
            originYardId
            originLongitude
            originLatitude
            originRegion
            originRegionId
            originDistrict
            originDistrictId
            destinationType
            destinationJob
            destinationJobId
            destinationLofa
            destinationLofaId
            destinationYard
            destinationYardId
            destinationLongitude
            destinationLatitude
            destinationRegion
            destinationRegionId
            destinationDistrict
            destinationDistrictId
            trailerType
            trailerTypeId
            trailer
            trailerId
            truckNumber
            carrierName
            carrierId
            driverName
            driverId
            status
            miles
            accessorialCost
            payCode
            readyForDispatchDateTime
            assignedDateTime
            atOriginIn
            atOriginOut
            atDestinationIn
            atDestinationOut
        }
    }
`;
